<template>
  <layout>
    <page-header :header="$t('orders.title')" />
    <div class="content">
      <admin-table v-bind="tableProps">
        <template slot="amount" slot-scope="{ item }">
          <order-final-amount :order="item" />
        </template>
        <template slot="status" slot-scope="{ item }">
          <order-status :order="item" class="mr-2" />
          <value-payment-method :item="item" />
        </template>
      </admin-table>
    </div>
  </layout>
</template>

<script>
import { AdminTable } from 'stylemix-vue-admin'
import { create } from 'vue-modal-dialogs'
import OrdersApi from './Api'
import View from './View'
import SystemUser from '../../../console/src/components/SystemUser'
import ValuePaymentMethod from '../../../console/src/components/values/ValuePaymentMethod'
import OrderStatus from '../../../console/src/orders/OrderStatus'
import OrderFinalAmount from '../../../console/src/orders/OrderFinalAmount'

const resourceBase = 'orders'

export default {
  name: 'Orders',

  components: {
    OrderFinalAmount,
    ValuePaymentMethod,
    AdminTable,
    SystemUser,
    OrderStatus,
  },

  data() {
    return {
      // Table resource configuration
      tableProps: {
        base: resourceBase,
        apiBuilder() {
          return new OrdersApi()
        },
        sortBy: 'created_at',
        sortDesc: true,
        perPage: 15,
        columns: [
          {
            key: 'invoice_number',
            label: this.$t('orders.number'),
            formatter: value => `#${value}`,
            sortable: true,
          },
          {
            key: 'description',
            label: this.$t('orders.description'),
          },
          {
            key: 'amount',
            label: this.$t('orders.amount'),
            sortable: true,
          },
          {
            key: 'status',
            label: this.$t('general.status'),
          },
          {
            key: 'completed_at',
            label: this.$t('orders.completed'),
            sortable: true,
            component: 'value-date',
            config: {
              stacked: true,
            },
          },
          {
            key: 'created_at',
            label: this.$t('orders.created'),
            sortable: true,
            component: 'value-date',
            config: {
              stacked: true,
            },
          },
        ],

        // override search fields here using fields schema
        searchFields: [
          {
            component: 'select-field',
            attribute: 'where.status',
            placeholder: this.$t('orders.all_statuses'),
            options: [
              { value: 'completed', label: this.$t('orders.completed') },
              { value: 'pending,partial', label: this.$t('orders.unpaid') },
              { value: 'cancelled', label: this.$t('orders.cancelled') },
              { value: 'refunding,refunded', label: this.$t('orders.refunds') },
            ],
          },
          {
            component: 'text-field',
            type: 'search',
            attribute: 'where.query',
            placeholder: this.$t('general.search'),
          },
          {
            component: 'date-range-field',
            attribute: 'where.created_at',
            placeholder: this.$t('orders.created_at'),
          },
        ],

        // define custom row actions
        rowActions: item => {
          const actions = [
            {
              label: this.$t('general.view'),
              variant: 'light',
              handler: () => {
                this.viewDialog(item)
              },
            },
          ]

          if (item.status === 'pending' || item.status === 'partial') {
            actions.push({
              label: this.$t('general.pay'),
              variant: 'success',
              handler: () => {
                this.$router.push({
                  name: 'orders.pay',
                  params: { id: item.id },
                })
              },
            })
          }

          return actions
        },

        // define custom bulk actions
        bulkActions() {
          return []
        },
      },
    }
  },

  created() {
    this.viewDialog = create(View, 'order')
  },
}
</script>
